<template>
  <transition name="submenu-fade-left" mode="out-in">
    <ul v-if="submenuType === 'case_study'" key="caseStudy" class="case-study">
      <li></li>
      <li>
        <router-link to="/project-mercedes">Mercedes</router-link>
      </li>
      <li>
        <router-link to="/project-pizzabox">Pizza Box</router-link>
      </li>
      <li>
        <router-link to="/project-nykart">Nykart</router-link>
      </li>
      <li>
        <router-link to="/project-social">Social Monster</router-link>
      </li>
      <li>
        <router-link to="/project-brilliant-mind">Brilliant Minds</router-link>
      </li>
      <li>
        <router-link to="/project-janczaki">Janczaki</router-link>
      </li>
      <li>
        <router-link to="/project-matthias">Matthias</router-link>
      </li>
      <li>
        <router-link to="/project-social-monster-new">Social Monster New</router-link>
      </li>
      <li>
        <router-link to="/project-streetwear">Streetwear</router-link>
      </li>
      <li></li>
    </ul>
    <ul v-if="submenuType === 'about'" key="Company" class="case-study">
      <li></li>
      <li></li>
      <li>
        <a v-on:click="showSubMenu=false; goToSection(10)" href="#">About</a>
      </li>
      <li>
        <a v-on:click="showSubMenu=false; goToSection(11)" href="#">Team</a>
      </li>
      <li></li>
      <li></li>
    </ul>
  </transition>
</template>

<script>
export default {
  name: "SubMenu",
  data() {
    return {};
  },
  props: ["submenuType"],
  methods: {
    goToSection: function(sectionNumber) {
      this.$emit("changeActiveSection", sectionNumber);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/SubMenu.vue